export const DISPLAY_DASHBOARD = 'DISPLAY_DASHBOARD'
export const DISPLAY_SPACY= 'DISPLAY_SPACY'
export const DISPLAY_CRON_LOGS = 'DISPLAY_CRON_LOGS'
export const DISPLAY_DEDUPLICATES = 'DISPLAY_DEDUPLICATES'
